module.exports = __webpack_public_path__ + "static/frontUserNew/img/template-orderlist.ce7aaa4e.png";